export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12210.8b08eb60.jpg";